import { render, staticRenderFns } from "./Mejora.vue?vue&type=template&id=c9748e10&scoped=true&lang=html&"
import script from "./Mejora.vue?vue&type=script&lang=js&"
export * from "./Mejora.vue?vue&type=script&lang=js&"
import style0 from "./Mejora.vue?vue&type=style&index=0&id=c9748e10&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9748e10",
  null
  
)

export default component.exports